export const HOME_LABEL = 'Home'
export const NEWS_SLUG = 'news'
export const LOCATIONS_SLUG = 'locations'
export const JOBS_SEARCH_SLUG = 'careers/job-search'
export const CAREERS_SLUG = 'careers'
export const INVESTORS_SLUG = 'investors'
export const PRODUCTS_SLUG = 'our-products'
export const STORY_SLUG = 'about-us/stories'
export const PATHNAME_SPACER = '/'
export const REGEX = /\b([a-zÁ-ú]{3,})/g
export const REGEX_SLUG = /-/g

export const TYPES_ENUM = Object.freeze({
  article: 'article',
  location: 'location',
  job: 'job',
  story: 'story',
})
